export enum GenderCodeEnum {
    Female = 'Female',
    Male = 'Male',
    Neutral = 'Neurtal',
}
